module.exports = __webpack_public_path__ + "img/step1.554b4110.png";